export const createContentGenerationFeedbackRequest = (contentGenerationTraceID, metadata, liked, feedbackText) => {
  return {
    method: "POST",
    url: "/content_generation_feedbacks",
    data: {
      content_generation_trace_id: contentGenerationTraceID,
      metadata,
      liked,
      feedback_text: feedbackText
    }
  }
}

